module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Scaffold', [_c('Loader', {
    attrs: {
      "loading": _vm.saving || _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "component-form"
    }
  }, [_c('header', [_c('h2', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.trads.subhead.interpolate({
    brand: _vm.brand.name
  })))])]), _vm._v(" "), _c('FormHead', {
    attrs: {
      "createMode": !_vm.data
    },
    model: {
      value: (_vm.headData),
      callback: function($$v) {
        _vm.headData = $$v
      },
      expression: "headData"
    }
  }), _vm._v(" "), (_vm.showCampaignStep) ? _c('FormDefaultCampaign', {
    on: {
      "changeCategories": _vm.changeCategories
    },
    model: {
      value: (_vm.defaultCampaignData),
      callback: function($$v) {
        _vm.defaultCampaignData = $$v
      },
      expression: "defaultCampaignData"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.headData.componentType) ? _c('FormReferences', {
    key: _vm.headData.componentType,
    attrs: {
      "componentType": _vm.headData.componentType
    },
    model: {
      value: (_vm.references),
      callback: function($$v) {
        _vm.references = $$v
      },
      expression: "references"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.clickedOnSaveAtLeastOnce && !_vm.canSave) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.trads.missingProperties))]) : _vm._e(), _vm._v(" "), _c('footer', [(_vm.data) ? _c('ClientColorButton', {
    attrs: {
      "class-name": 'back',
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('goBack');
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$trad.common.cancel) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('ClientColorButton', {
    attrs: {
      "disabled": _vm.clickedOnSaveAtLeastOnce && !_vm.canSave
    },
    on: {
      "click": function($event) {
        _vm.canSave ? _vm.save() : (_vm.clickedOnSaveAtLeastOnce = true);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$trad.common.save) + "\n                ")]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.reset))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dfbbeb5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-form/component-form.vue
// module id = 3135
// module chunks = 0